<div class="card-header bg-light">
  <h4 class="card-title mb-0">
    <i class="far fa-file"></i>
    {{titulo}}
  </h4>
</div>
<div class="p-2 wrapper">
  <form [formGroup]="form" #f="ngForm">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label class="form-label">Nº da Constatação</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="numeroConstacacao" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
      <div class="col-md-4 mb-2">
        <label class="form-label">Associado à</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="numeroOsa" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>

      <div class="col-md-4 mb-2">
        <label class="form-label">Nº da Nota de Auditoria</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="nNotaAuditoriaExecucao" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 mb-2">
        <label class="form-label">Responsável</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="nomeResponsavel" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
      <div class="col-md-4 mb-2">
        <label class="form-label">Status</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="statusDescricao" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
      <div class="col-md-4 mb-2">
        <label class="form-label">Avaliação</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="avaliacaoDescricao" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
    </div>

    <div class="col-md-12 mb-2">
      <label class="form-label">Título</label>
      <input type="text" class="form-control form-control-sm" formControlName="titulo" name="titulo"
             [ngClass]="{ 'is-invalid': submitted && form.controls['titulo'].invalid }" maxlength="50">
      <div *ngIf="submitted && form.controls['titulo'].invalid" class="invalid-feedback">
        <div *ngIf="form.controls['titulo'].errors.required">Campo obrigatório</div>
      </div>
    </div>

    <div class="col-md-12 mb-2">
      <label class="form-label" for="descricaoConstatacao">Descrição da Constatação</label>
      <angular-editor *ngIf="!visualizar; else visualizarDescricaoCons" #myDiv [config]="config" id="descricaoConstatacao" rows="40"
                      formControlName="descricaoConstatacao" (ngModelChange)="onEditorChange($event, 'descricaoConstatacao')"
                      [ngClass]="{ 'is-invalid': submitted && form.controls['descricaoConstatacao'].invalid }"></angular-editor>
      <ng-template #visualizarDescricaoCons>
        <div class="form-control" [innerHTML]="form.controls['descricaoConstatacao'].value"
             style="min-height: 150px; max-height: 300px; overflow-y: auto;">
        </div>
      </ng-template>
      <div *ngIf="submitted && form.controls['descricaoConstatacao'].invalid" class="invalid-feedback">
        <div *ngIf="form.controls['descricaoConstatacao'].errors.required">Campo obrigatório</div>
      </div>
    </div>

    <!-- SEÇÃO DE ARQUIVOS MOVIDA PARA CÁ -->
    <div class="col-md-12 mb-3">
      <div class="mat-elevation-z4">
        <table mat-table [dataSource]="dataSource" class="w-100" matSort matSortDisableClear>
          <tr mat-header-row *matHeaderRowDef="['arquivo', 'acoes']" class="bg-light"></tr>
          <ng-container matColumnDef="arquivo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivos</th>
            <td mat-cell *matCellDef="let element">
              <small (click)="Download(element)" class="download">{{ element?.nomeArquivo }}</small>
            </td>
          </ng-container>
          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-right">
              <span *ngIf="!visualizar">
                <label for="file" class="btn btn-success btn-xs"> Adicionar</label>
                <input type="file" id="file" name="file[]" multiple="multiple" style="display: none"
                       [accept]="acceptTypes" (change)="anexarArquivosItem($event)" />
              </span>
            </th>
            <div class="w-100 d-flex justify-content-center">
              <td mat-cell *matCellDef="let element; let i = index" class="block">
                <div class="w-100 d-flex justify-content-center">
                  <button type="button" class="btn btn-danger btn-xs text-left" (click)="excluirArquivo(element?.id)"
                          *ngIf="!visualizar">
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </td>
            </div>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: ['arquivo', 'acoes']"></tr>
        </table>
        <h5 [hidden]="dataSource?.data?.length > 0" class="table-no-data">
          Nenhum registro encontrado
        </h5>
        <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>

    <div class="col-md-12 mb-2">
      <label class="form-label" for="descricaoRecomendacao">Descrição da Recomendação</label>
      <angular-editor *ngIf="!visualizar; else visualizarDescricaoRec" #myDiv [config]="config" id="descricaoRecomendacao" rows="40"
                      formControlName="descricaoRecomendacao" (ngModelChange)="onEditorChange($event, 'descricaoRecomendacao')"
                      [ngClass]="{ 'is-invalid': submitted && form.controls['descricaoRecomendacao'].invalid }"></angular-editor>
      <ng-template #visualizarDescricaoRec>
        <div class="form-control" [innerHTML]="form.controls['descricaoRecomendacao'].value"
             style="min-height: 150px; max-height: 300px; overflow-y: auto;">
        </div>
      </ng-template>
      <div *ngIf="submitted && form.controls['descricaoRecomendacao'].invalid" class="invalid-feedback">
        <div *ngIf="form.controls['descricaoRecomendacao'].errors.required">Campo obrigatório</div>
      </div>
    </div>
  </form>
</div>
<div class="card-footer">
  <button type="submit" class="btn btn-primary btn-sm mr-1" (click)="salvar(false, true)" *ngIf="!visualizar">
    <i class="far fa-save"></i> Salvar
  </button>
  <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
    <i class="fas fa-times"></i> Fechar
  </button>
</div>
